import { Component, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../services/httpService';



declare var cabbage: any;


@Component({
  selector: 'app-pay-with-bank',
  templateUrl: './pay-with-bank.component.html',
})
export class PayWithBankComponent {





  source;
  connector;
  public_token = "";
  constructor(public router: Router, private activeRoute: ActivatedRoute, private httpService: HttpService
  ) {


   

    //this.source = 'x37hcmk2';
    //this.connector = 'link_production_wj0ut69zz8t1oz0bko3aoqmu';
    //this.fetchVendor();



    this.fetchLink();

    //cabbage.initializeLink(this.source);
    //initializaConnectPayLink(this.connector);
  }





  //show() {
  //  cabbage.displayPayLink(this.source);
  //}


  connect() {
    cabbage.whiteLabelOpenLink(this.connector);
  }


  result;

  fetchLink() {



    this.httpService.post<any>('Store/create-link-token-white-label', false).subscribe(
      resp => {


        this.result = JSON.parse(resp.message);

        if (this.result.message == "success") {

          this.connector = this.result.link_token;
          console.log("happy", this.connector)
          cabbage.whiteLabelInitializeLink(this.connector);

        }


        //this.loading = false;

      },
      error => {
        //this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });





  }







  @HostListener('window:message', ['$event'])
  onMessage(event) {


    //console.log(event)

    //if (event.origin == "https://cdn-sandbox.cabbagepay.com") {

      const data = JSON.parse(event.data);
      //console.log(data.message)

      if (data.message == "success") {

        this.public_token = data.public_token;
        cabbage.whiteLabelCloseLink();
        console.log(data.public_token)

      }



      if (data.message == "terminated") {
        console.log("termination")
        cabbage.whiteLabelCloseLink();


      }


    



    //cabbage.closeLink();



  };

}
